/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_MarcaCarga as MarcaCarga,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_api as api,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function FormularioCatalogoMovilidad({
  recurso: e,
  titulo: t,
  placeholder: n,
  editar: r,
  onClose: i,
  onGuardado: a,
}) {
  let [o, s] = (0, React.useState)(r?.nombre ?? ``),
    [c, l] = (0, React.useState)(!r || r.activo),
    [u, f] = (0, React.useState)(``),
    [p, m] = (0, React.useState)(!1);
  async function h(t) {
    if ((t.preventDefault(), !p)) {
      (m(!0), f(``));
      try {
        (await api(`/transporte/${e}`, {
          method: `POST`,
          body: JSON.stringify({
            id: r?.id ?? null,
            nombre: o.trim(),
            activo: c,
          }),
        }),
          a());
      } catch (e) {
        f(e.message);
      } finally {
        m(!1);
      }
    }
  }
  return (
    <Modal
      titulo={t}
      onClose={i}
      children={
        <form
          onSubmit={h}
          className={`flex flex-col gap-3`}
          children={[
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Nombre`,
                <input
                  autoFocus={!0}
                  value={o}
                  onChange={(e) => s(e.target.value)}
                  placeholder={n}
                  className={Lo}
                />,
              ]}
            />,
            r && (
              <MarcaCarga
                checked={c}
                onChange={l}
                children={`Se ofrece al pedir movilidad`}
              />
            ),
            u && <p className={`text-sm text-(--error)`} children={u} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={i}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={p || !o.trim()}
                  className={Ro}
                  children={p ? `Guardando…` : `Guardar`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
